import React, { useEffect } from 'react';

// Dark mode has been retired in favour of the single warm editorial light
// theme. This component renders nothing and ensures the `dark` class is never
// left applied (e.g. from a previous session's localStorage).
const ThemeToggle = () => {
  useEffect(() => {
    document.documentElement.classList.remove('dark');
  }, []);
  return null;
};

export default ThemeToggle;
